import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton } from 'core/components';
import { PreviewLayout, PageFooter } from 'core/layouts';
import { PatientPreviewTabs } from '../components';

function PatientPreviewTemplate({ patientPreviewViewStore, t }) {
    const {
        item,
        loaderStore,
        rootStore        
    } = patientPreviewViewStore;

     const payorsPolicyInfo = item ? item.patientInsuranceInfo.payors.map(item =>
        <tr key={item.brightreeID}>
            <td><React.Fragment>{item.payorLevel}</React.Fragment></td>
            <td><React.Fragment>{item.payPercent}</React.Fragment></td>
            <td><React.Fragment>{item.payorPolicyInfo.groupNumber}</React.Fragment></td>
            <td><React.Fragment>{item.payorPolicyInfo.name}</React.Fragment></td>
            <td><React.Fragment>{item.payorPolicyInfo.policyNumber}</React.Fragment></td>
            <td className="type--center"><React.Fragment>{item.payorPolicyInfo.verified ? 
                <i className="u-icon u-icon--sml u-icon--active"></i> : 
                <i className="u-icon u-icon--sml u-icon--inactive"></i>}</React.Fragment>
            </td>
        </tr>
    ) : [];

    const diagnosis = item ? item.patientClinicalInfo.diagnosisCodes.map(item =>
        <tr key={item.icdCode}>
            <td><React.Fragment>{item.description}</React.Fragment></td>
            <td><React.Fragment>{item.icdCode}</React.Fragment></td>
        </tr>
    ) : [];
    
    return (
        <PreviewLayout store={patientPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            {item ? <PatientPreviewTabs route="master.app.main.patient.preview.general" 
                queryParams={rootStore.routerStore.routerState.params} 
                patient={item.patientGeneralInfo}/> : null}
            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med is-preview">
                        <h4 className="form__title form__title--preview u-mar--bottom--med">General info</h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.FIRST_NAME')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.patientGeneralInfo.name.first}</React.Fragment>}
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.LAST_NAME')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.name.last}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.BIRTH_DATE')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.birthDate}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.DELIVERY_PHONE')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryPhone}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.ADDRESS_LINE1')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.addressLine1}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.ADDRESS_LINE2')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.addressLine2}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.ADDRESS_LINE3')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.addressLine3}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.CITY')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.city}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.COUNTRY')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.country}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.POSTAL_CODE')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.postalCode}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.STATE')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.deliveryAddress.state}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.PLACE_OF_SERVICE')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientGeneralInfo.placeOfService.value}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4 className="form__title form__title--preview u-mar--bottom--med">Clinical info</h4>
                        <div className="row u-mar--bottom--lrg"> 
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.GENDER')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientClinicalInfo.gender}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.MARKETING_REFERRAL.REFERRAL_TYPE')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientClinicalInfo.marketingReferral ? item.patientClinicalInfo.marketingReferral.referralTypeName :"N/A"}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('PATIENT.PREVIEW.ORDERING_DOCTOR')}</div>                            
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.patientClinicalInfo.orderingDoctor && item.patientClinicalInfo.orderingDoctor.doctor ? item.patientClinicalInfo.orderingDoctor.doctor.value : 'N/A'}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h4 className="form__title form__title--preview u-mar--bottom--med">Diagnosis</h4>
                        <div className="u-mar--bottom--lrg">
                            <table className="table--preview">
                                <colgroup>
                                    <col />
                                    <col width="150" />
                                </colgroup>
                                <thead >
                                    <tr>
                                        <th>Description</th>
                                        <th>ICD Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {diagnosis}
                                </tbody>
                            </table>
                        </div>

                        <div className="row">
                            <div className="col col-sml-12 col-lrg-12">
                                <h4 className="form__title form__title--preview u-mar--bottom--med">Payors</h4>

                                <table className="table--preview">
                                    <thead >
                                        <tr>
                                            <th>Payor Level</th>
                                            <th>Pay Percent</th>
                                            <th>Group Number</th>
                                            <th>Name</th>
                                            <th>Policy Number</th>
                                            <th className="type--center">Verified</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payorsPolicyInfo}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PageFooter>
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label={('LIST_LAYOUT.BACK_BUTTON')}
                    onClick={() => rootStore.routerStore.goBack()}
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                />
            </PageFooter>
        </PreviewLayout>
    )
}

PatientPreviewTemplate.propTypes = {
    patientPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(PatientPreviewTemplate);
